import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X8BlockType, X8BlockUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class AddBlockStore implements SaveStateHolder {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly pushableBlockId: number,
              readonly blockType: X8BlockType) {
    makeObservable(this);
    this.save = null;
  }  

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    const model: X8BlockUpdateModel = {
      PushableBlockId: this.pushableBlockId,
      BlockType: this.blockType,
      BlockId: null,
      Bal: null
    };
    this.save = contentLoaders.x8block.insert(model);
  }

  @action
  completeBal(blockId: number, blockBal: number) {
    // debugger;

    if (this.save?.isPending === true)
      return;
     const model: X8BlockUpdateModel = {
        PushableBlockId: this.pushableBlockId,
        BlockType: this.blockType,
        BlockId: blockId,
        Bal: blockBal
      };
    this.save = contentLoaders.x8block.insertBal(model);
  }
}
